<template>
  <button
    class="rounded text-white font-bold transition"
    :class="[`btn-size-${size} color-${color} hover-color-${hoverColor}`,
      { 'pointer-events-none': disabled },
    ]"
    @click="$emit('click', $event)"
   >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'GrmBtn',
  props: {
    size: { type: String, default: 'sm' },
    color: { type: String, default: 'blue' },
    disabled: { type: Boolean, default: false },
    hoverColor: { type: String, default: function() { return this.color } },
  },
}
</script>

<style lang="scss" scoped>
.btn-size- {
  &xs { @apply text-xs px-2 py-1 }
  &sm { @apply text-sm px-3 py-2 }
  &md { @apply text-base px-4 py-3 }
  &lg { @apply text-lg px-5 py-4 }
  &xl { @apply text-xl px-6 py-5 }
}

.color- {
  &gray { @apply bg-gray-400 }
  &red { @apply bg-red-400 }
  &yellow { @apply bg-yellow-400 }
  &green { @apply bg-green-600 }
  &blue { @apply bg-blue-400 }
  &indigo { @apply bg-indigo-400 }
  &purple { @apply bg-purple-400 }
  &pink { @apply bg-pink-400 }
  &black { @apply bg-black }
  &navy { @apply bg-navy }
}

.hover-color- {
  &gray { @apply hover:bg-gray-600 }
  &red { @apply hover:bg-red-600 }
  &yellow { @apply hover:bg-yellow-600 }
  &green { @apply hover:bg-green-800 }
  &blue { @apply hover:bg-blue-600 }
  &indigo { @apply hover:bg-indigo-600 }
  &purple { @apply hover:bg-purple-600 }
  &pink { @apply hover:bg-pink-600 }
}
</style>